import { Box, Button, Grid, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function LipidProfileTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Total Cholesterol" size="small" variant="outlined" name="totalCholesterol" type="number" {...register('totalCholesterol')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HDL Cholesterol" size="small" variant="outlined" name="hdlCholesterol" type="number" {...register('hdlCholesterol')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="LDL Cholesterol" size="small" variant="outlined" name="ldlCholesterol" type="number" {...register('ldlCholesterol')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Triglyceride" size="small" variant="outlined" name="triglyceride" type="number" {...register('triglyceride')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="VLDL" size="small" variant="outlined" name="vldl" type="number" {...register('vldl')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
